import { useEffect, useState } from 'react'
import { FormGroup, Label, Input, Collapse } from 'reactstrap'
import { useRecoilValue } from 'recoil'

import { isNull } from '../../../izUtils'
import { multiCheckLoading } from '../../../recoil/recoil'
import Loader from '../../spinner/Loader'
import DictionaryInfoButton from '../../dictionary/DictionaryInfoButton'

const FacilityMultiCheck = ({ data, onChange, showErrors, component, showDictionary }) => {
    const { name, display, errors, title, values, disabled, mandatory } = data
    const multiLoading = useRecoilValue(multiCheckLoading)

    const [value, setValue] = useState([])
    const [openFacilities, setOpenFacilities] = useState([])

    useEffect(() => {
        setValue(isNull(data.value) ? [] : [...data.value])
    }, [data.value])

    const handleFacilityChange = (facilityId) => {
        let clonedValue = [...value]
        const facilityIndex = clonedValue.findIndex(item => item.id === facilityId)

        if (facilityIndex !== -1) {
            clonedValue.splice(facilityIndex, 1)
        } else {
            clonedValue.push({ id: facilityId, security_systems: [] })
            setOpenFacilities([...openFacilities, facilityId])
        }

        setValue(clonedValue)
        onChange(clonedValue, name, component)
    }

    const handleSecuritySystemChange = (facilityId, securitySystemId) => {
        let clonedValue = [...value]
        const facilityIndex = clonedValue.findIndex(item => item.id === facilityId)

        if (facilityIndex !== -1) {
            const securitySystems = clonedValue[facilityIndex].security_systems || []

            if (securitySystems.includes(securitySystemId)) {
                clonedValue[facilityIndex].security_systems = securitySystems.filter(id => id !== securitySystemId)
            } else {
                clonedValue[facilityIndex].security_systems = [...securitySystems, securitySystemId]
            }

            setValue(clonedValue)
            onChange(clonedValue, name, component)
        }
    }

    const isFacilityChecked = (facilityId) => value.some(item => item.id === facilityId)
    const isSecuritySystemChecked = (facilityId, securitySystemId) => {
        const facility = value.find(item => item.id === facilityId)
        return facility && facility.security_systems && facility.security_systems.includes(securitySystemId)
    }

    if (display) {
        return (
            <FormGroup style={{ position: 'relative' }}>
                {(multiLoading === name + '-' + component?.id) && <Loader />}
                <div className="d-flex align-items-center">
                    <Label>{title + (mandatory ? " *" : "")}</Label>
                    {(showDictionary && showDictionary.fields?.includes(name)) &&
                        <DictionaryInfoButton code={`${showDictionary.form}.form.${name}`} id={`${showDictionary.form}.form.${name}`} marginBottom="0.2rem" />
                    }
                </div>
                {(!isNull(values) && values.length !== 0) ?
                    <div className="custom-control custom-checkbox form-check" data-name={name}>
                        {values.map((facility, index) => {
                            const facilityChecked = isFacilityChecked(facility.id)
                            const isOpen = openFacilities.includes(facility.id)
                            const hasSecuritySystems = !isNull(facility.security_systems) && facility.security_systems.length > 0

                            return (
                                <div key={`${name}_${index}_${facility.id}`} className="py-1">
                                    <div className="form-checkbox-group d-flex align-items-center">
                                        <div className='me-2'>
                                            <Input
                                                className="custom-control-input"
                                                id={`${facility.id}-${component?.id || ''}`}
                                                type="checkbox"
                                                onChange={() => handleFacilityChange(facility.id)}
                                                checked={facilityChecked}
                                                disabled={disabled || (multiLoading === name + '-' + component?.id)}
                                            />
                                            <Label className="checkmark" htmlFor={`${facility.id}-${component?.id || ''}`}></Label>
                                            <label className="custom-control-label" htmlFor={`${facility.id}-${component?.id || ''}`}>
                                                {facility.title}
                                            </label>
                                        </div>
                                        {hasSecuritySystems && facilityChecked && (
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-link p-0 ms-auto"
                                                onClick={() => setOpenFacilities(isOpen ?
                                                    openFacilities.filter(id => id !== facility.id) :
                                                    [...openFacilities, facility.id]
                                                )}
                                            >
                                                <i className={`fa fa-chevron-${isOpen ? 'up' : 'down'}`}></i>
                                            </button>
                                        )}
                                    </div>

                                    {hasSecuritySystems && facilityChecked && (
                                        <Collapse isOpen={isOpen}>
                                            <div className="ms-4 ps-2 pt-1">
                                                {facility.security_systems.map((securitySystem, ssIndex) => (
                                                    <div key={`ss_${facility.id}_${ssIndex}`} className="form-checkbox-group d-flex align-items-center">
                                                        <div className='me-2'>
                                                            <Input
                                                                className="custom-control-input"
                                                                id={`${facility.id}_${securitySystem.id}-${component?.id || ''}`}
                                                                type="checkbox"
                                                                onChange={() => handleSecuritySystemChange(facility.id, securitySystem.id)}
                                                                checked={isSecuritySystemChecked(facility.id, securitySystem.id)}
                                                                disabled={disabled || (multiLoading === name + '-' + component?.id)}
                                                            />
                                                            <Label className="checkmark" htmlFor={`${facility.id}_${securitySystem.id}-${component?.id || ''}`}></Label>
                                                            <label className="custom-control-label" htmlFor={`${facility.id}_${securitySystem.id}-${component?.id || ''}`}>
                                                                {securitySystem.title}
                                                            </label>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </Collapse>
                                    )}
                                </div>
                            )
                        })}
                    </div>
                    :
                    <div className="form-checkbox-group mb-1 ms-1">/</div>
                }
                {!isNull(showErrors) && showErrors && !isNull(errors) && errors.length !== 0 &&
                    <div style={{ color: "red", marginBottom: "10px" }}>
                        {errors.map((error, index) => <div key={"error-" + index}>{error}</div>)}
                    </div>
                }
            </FormGroup>
        )
    } else {
        return null
    }
}

export default FacilityMultiCheck
